<template>
    <div class="bigBox">
        <div class="historyBody" v-if="isShowHistory">
            <div class="backBtn" @click="isShowHistory = false">
                <img class="backIcon" src="@/assets/images/strategy/back.png" alt  />
                返回
            </div>
            <div class="h60"></div>
            <history-data  @close="isShowHistory = false" ></history-data>
        </div>
        <div class="body" v-else >
            <div class="topBlock">
                <div class="cont">
                    <div class="historyBlock">
                        <div class="historyBtn" @click="isShowHistoryData">查看历史数据</div>
                        <span class="tipTitle">指标定义</span>
                        <el-popover
                            placement="right"
                            width="100%"
                            trigger="hover"
                            style="font-size:0"
                            >
                            <div>
                                <div class="tipsTitle">新会员首购率：</div>
                                <div class="tipsCont">新会员首购率=当月新会员购买客户数/当月新入会人数*100%</div>
                                <div class="tipsTitle">已购会员占比：</div>
                                <div class="tipsCont">已购会员占比=已购会员数/成交客户数*100%</div>
                                <div class="tipsTitle">近90天复购率：</div>
                                <div class="tipsCont">近90天复购率=近90天复购客户数/近90天成交客户数*100%</div>
                                <div class="tipsCont">近90天购买次数≥2即为近90天复购客户</div>
                                <div class="tipsTitle">流失客户占比：</div>
                                <div class="tipsCont">流失客户占比=流失客户数/历史成交总客户数*100%</div>
                                <div class="tipsCont">最后一次购买时间在1年前年即为流失客户</div>
                            </div>
                            <img slot="reference" src="@/assets/images/strategy/tips.svg" alt  />
                        </el-popover>
                    </div>
            
                    <div class="resultBlock">
                        <div class="title">客户运营诊断：</div>
                        <div class="result" v-if="resultGood">
                            <div class="resultItem" style="background: #FA4B6C;" v-if="resultGood == 2">不</div>
                            <div class="resultItem" :style="resultGood == 1 ? 'background: #10AEA3;' : 'background: #FA4B6C;'">达</div>
                            <div class="resultItem" :style="resultGood == 1 ? 'background: #10AEA3;' : 'background: #FA4B6C;'">标</div>
                        </div>
                        <div class="tips">
                            <div v-if="resultGood == 1">很棒！各项数据指标均正常，请继续保持！</div>
                            <div v-else>
                                <div>
                                检测到
                                <span style="text-decoration:underline;color:#31FDFD" v-if="slaveDiag[0].status == 1">新会员首购</span>
                                <span class="orIcon"
                                 v-if="(slaveDiag[1].status == 1 && slaveDiag[0].status == 1) 
                                 || (slaveDiag[2].status == 1 && slaveDiag[0].status == 1)
                                 || (slaveDiag[3].status == 1 && slaveDiag[0].status == 1)
                                "> / </span>
                                <span style="text-decoration:underline;color:#31FDFD" v-if="slaveDiag[1].status == 1">近90天复购</span>
                                <span class="orIcon" v-if="(slaveDiag[1].status == 1 && slaveDiag[2].status == 1)
                                || (slaveDiag[1].status == 1 && slaveDiag[3].status == 1)
                                "> / </span>

                                <span style="text-decoration:underline;color:#31FDFD" v-if="slaveDiag[2].status == 1">已购会员</span>
                                <span class="orIcon" v-if="slaveDiag[2].status == 1 && slaveDiag[3].status == 1"> / </span>

                                <span style="text-decoration:underline;color:#31FDFD" v-if="slaveDiag[3].status == 1">流失客户</span>
                                指标异常，请继续提升!
                                </div>
                                <div style="padding-top: 5px;">以下策略请尝试~</div>
                            </div>
                        </div>
                        <div class="btnGroup">
                            <div class="solutionBtn" @click="go">立即解决</div>
                            <!-- <a href="#targetLocation" class="solutionBtn">立即解决</a> -->
                            <div class="indicatorsBtn" @click="isShowCustomDialog">自定义指标</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="slaveBlock">
                <div v-for="(item,int) in slaveDiag" :key="int" class="slaveItem">
                    <div class="tips" style="    transition: all 0.3s;"
                    :style="item.status !== 1?'background: rgba(0,190,48,0.15);':'background: rgba(254,77,69,0.15);'" 
                    v-if="item.status">
                        <span class="tips1" v-if="item.status ==1">紧急提升</span>
                        <span class="tips2" v-else-if="item.status == 2">达标</span>
                        <span class="tips2" v-else-if="item.status == 3 ">优秀</span>
                    </div>
                    <div style="display:flex">

                        <img :src="item.icon" alt class="iconImg" />
                        
                        <div>
                            <div class="num">
                                <countTo  :endVal='item.num' :duration='1000' decimal="." :decimals="2" suffix="%" :autoplay="countToStart"></countTo>
                                </div>
                            <div class="name">{{ item.name }}</div>
                            <div class="desc">{{ item.title }} {{ item.totle }}</div>
                        </div>
                    </div>
                </div>
            </div>

            <div style="position: relative;" id="targetLocation">
                <div class="tabCheck">
                    <div class="nav" ref="mainHeader">
                        <span
                            class="nav-item"
                            style="position: relative;display: flex;align-items: center;"
                            :class="{ navActive: topActive == ind }"
                            @click="topTab(ind, item)"
                            v-for="(item, ind) in headItem"
                            :key="ind"
                            >
                            <img style="height:20px;margin-right:10px"  v-if="topActive == ind" :src="item.icon2" alt  />
                            <img style="height:20px;margin-right:10px"  v-else :src="item.icon1" alt  />
                            {{ item.title }}
                        </span>
                        <i class="nav-underline" :style="navLineStyle"></i>
                    </div>

                    <!-- 行业运营策略 -->
                    <div v-if="topActive === 0">
                        <industry-operation :isData="isData"></industry-operation>

                    </div>

                    <!-- 我的使用策略 -->
                    <div v-if="topActive === 1">
                        <my-strategy></my-strategy>
                    </div>
                </div>
            </div>

            <div style="height:87px"></div>

            <custom-dialog v-if="isShowCustom" @close="isShowCustom = false" @onSave="saveCustom"></custom-dialog>
        </div>
    </div>
</template>
    
<script>
import countTo from "vue-count-to"
import industryOperation from './components/industryOperation'
import myStrategy from './components/myStrategy'
import customDialog from './components/customDialog'
import historyData from './components/historyData.vue'
import {
	operationData
} from "@/api/industry/strategy.js";
export default {
name: '' ,
components: {
    industryOperation,
    myStrategy,
    customDialog,
    historyData,
    countTo
},
props:{},
data() {
    return {
        resultGood:false,//是否达标
        countToStart:false,
        isData:{},
        slaveDiag:[
            {
                icon:require('@/assets/images/strategy/Recruit.png'),
                name:'新会员首购率',
                title:'当月新会员数',
            },
            {
                icon:require('@/assets/images/strategy/Purchased.png'),
                name:'已购会员占比',
                title:'已购会员数',
            },
            {
                icon:require('@/assets/images/strategy/Repurchase.png'),
                name:'近90天复购率',
                title:'近90天复购客户数',
            },
            {
                icon:require('@/assets/images/strategy/Loss.png'),
                name:'流失客户占比',
                title:'流失客户数',
            }
        ],
        headItem:[
            {
                title:'行业运营策略',
                icon1:require('@/assets/images/strategy/行业运营策略-未选中.png'),
                icon2:require('@/assets/images/strategy/行业运营策略-选中.png'),
            },
            {
                title:'我的使用策略',
                icon1:require('@/assets/images/strategy/我使用的策略-未选中.png'),
                icon2:require('@/assets/images/strategy/我使用的策略-选中.png'),
            }
        ],
        topActive:0,
        activeNavStyle: { left: 360, width: 0 },
        isShowCustom:false,//控制自定义弹窗
        isShowHistory:false,//控制历史数据弹窗
    }
},
computed: {
    navLineStyle() {
      let style = this.activeNavStyle;
      return {
        width: `${style.width}px`,
        left: `${style.left}px`,
      };
    },
},
created() {

},
mounted() {
    this.getoperationData()
    this.activeNavStyle = this.getNavStyle(0);
    //事件埋点方法
    this.buriedPoint(1,  "行业运营策略",'行业专区', "行业运营策略")
},
methods: {
    go(){
        this.buriedPoint(2,  "行业专区/运营策略/立即解决" ,'行业专区', "行业运营策略")
        document.getElementById('targetLocation').scrollIntoView({ behavior: 'smooth' })
    },
    //获取数据
    getoperationData(){
        const loading = this.$loading({
          lock: true,
          text: '正在诊断，请耐心等待1-5分钟',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)',
          customClass:'LoadingStyle'
        });
        operationData().then((res) => {
            if(res.code === 1){

                this.isData= res

                this.resultGood= res.data.diagnosisStatus

                this.slaveDiag[0].totle= res.data.newMemberNum
                this.slaveDiag[0].num= res.data.newMemberFirstBuyRate
                this.slaveDiag[0].status=res.data.firstDiagnosisStatus
        
                this.slaveDiag[1].totle= res.data.purchasedMemberNum
                this.slaveDiag[1].num= res.data.purchasedMemberBuyRate
                this.slaveDiag[1].status=res.data.purchasedDiagnosisStatus

                this.slaveDiag[2].totle= res.data.purchasedMember90Num
                this.slaveDiag[2].num= res.data.purchased90Rate
                this.slaveDiag[2].status=res.data.purchased90DiagnosisStatus

                this.slaveDiag[3].totle= res.data.lossNum
                this.slaveDiag[3].num= res.data.lossRate
                this.slaveDiag[3].status=res.data.lossDiagnosisStatus

                this.countToStart= true
            }else{
                this.$message.warning(res.message);
            }
            loading.close();
      });
	},
    //滑动条
    topTab(ind, item){
        ind==0?this.buriedPoint(2,  "行业专区/行业运营策略/行业运营策略", '行业专区', "行业运营策略"):this.buriedPoint(2,"行业专区/行业运营策略/我的使用策略" , '行业专区',  "行业运营策略")
        this.topActive = ind;
        this.activeNavStyle = this.getNavStyle(ind);
    },
    getNavStyle(index) {
    if(!this.isShowHistory){
        let childNodes = this.$refs.mainHeader.childNodes;
        let width = Number(childNodes[index] && childNodes[index].clientWidth);
        let left = 360;
        if (index > 0) {
            for (let i = 0; i < index; i++) {
            if (this.screenWidth < 1370) {
                left += childNodes[i].clientWidth + 105;
            } else if (this.screenWidth > 1369 && this.screenWidth < 1572) {
                left += childNodes[i].clientWidth + 105;
            } else if (this.screenWidth > 1572 && this.screenWidth < 1800) {
                left += childNodes[i].clientWidth + 129;
            } else {
                left += childNodes[i].clientWidth + 145;
            }
            }
        }
        return { width, left };
      }
    },
    //显示自定义弹窗
    isShowCustomDialog(){
        this.buriedPoint(2, "行业专区/运营策略/自定义指标" , '行业专区',"行业运营策略")
        this.isShowCustom = true
    },
    //刷新自定义数据
    saveCustom(){
        this.isShowCustom = false
        this.getoperationData()
    },
    //显示历史数据
    isShowHistoryData(){
        this.isShowHistory = true
        this.buriedPoint(2, "行业专区/运营策略/历史数据", '行业专区', "行业运营策略")
    }
}
}
</script>
<style lang='scss'>
.LoadingStyle{
    .el-loading-spinner i{
     color: #FFFFFF !important;
     font-size: 20px;
    }
    .el-loading-spinner .el-loading-text{
        color: #FFFFFF !important;
        padding: 10px 0 ;
        font-size: 16px;
    }
}
</style>
<style lang='scss' scoped>
.body{ 
    background: #FBFBFF;
}
.historyBody{
    background:#FFFFFF;
}
.backBtn{
    cursor: pointer;
    display: flex;
    align-items: center;
    font-size: 16px;
    color: #666666;
    position: absolute;
    left: 30px;
    margin-top: 25px;
    .backIcon{
        width: 24px;
        height: 24px;
    }
}

.h60{
		float: left;
		width: 100%;
		height: 60px;
		margin-top: -60px;
		background-color: #6461e7;
	}
.tipsTitle{
    font-size:14px;
    font-weight: bold;
    color:#333333;
    margin:8px 0 5px 0;
}
.tipsTitle:first-child{
    margin:0 0 5px 0; 
}
.tipsCont{
    font-size:12px;
    color: #666666;
}
.topBlock{
 background-image: url("../../assets/images/strategy/top_banner.png");
  background-position: center top;
  background-repeat: no-repeat;
  background-size: auto 640px;
  margin-top: -60px;
  padding-top: 110px;
  height: 640px;
    .cont{
        width: 1200px;
        margin: -60px auto 0;
        padding-top: 90px;
    }
    .historyBlock{
        font-size: 14px;
        font-weight: 400;
        color: #FFFFFF;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        .historyBtn{
            border: 1px solid #FFFFFF;
            // width: 103px;
            // height: 32px;
            padding:8px;
            background: transparent;
            border-radius: 4px;
            cursor: pointer;
            white-space: nowrap;
            font-size: 16px;
        }
        .tipTitle{
            margin: 0 4px 0 16px ;   
        }
    }

    .resultBlock{
        margin: 65px 0 0 0;
        .title{
            font-size: 20px;
            font-weight: 400;
            color: #FFFFFF;
        }
        .result{
            display: flex;
            justify-content: flex-start;
            align-items: center;
            margin: 20px 0 0 0;
            .resultItem{
                font-size: 32px;
                font-weight: bold;
                color: #FFFFFF;
                width: 50px;
                height: 50px;
                margin: 0 8px 0 0;
                border-radius: 4px;
                text-align: center;
                line-height: 45px;
            }
        }

        .tips{
            font-size: 14px;
            font-weight: 400;
            color: #FFFFFF;
            margin: 20px 0 30px 0;
        }

        .btnGroup{
            display: flex;
            align-items: center;
            justify-content: flex-start;
            line-height: 34px;
            text-align: center;
            opacity: 1;
            font-size: 16px;
            font-weight: 400;
            .solutionBtn{
                width: 128px;
                height: 34px;
                border-radius: 17px;
                color: #0F0068;
                background: #31FDFD;
                cursor: pointer;
            }
            a:hover {
                text-decoration: none;
            }

            .indicatorsBtn{
                border-radius: 17px;
                width: 128px;
                height: 34px;
                margin-left: 12px;
                color: #FFFFFF;
                border: 1px solid #FFFFFF;
                cursor: pointer;
                display: flex;
                justify-content: center;
                align-items: center;
            }
        }
    }
}
.slaveBlock{
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin:-70px auto 0;
        width: 1200px;
        .slaveItem{
            background: #FFFFFF;
            box-shadow: 0px 3px 50px 0px rgba(69,50,182,0.1);
            border-radius: 8px 8px 8px 8px;
            opacity: 1;
            padding: 30px;
            position: relative;
            width: 288px;
            .tips{
                position: absolute;
                top: 0;
                right: 0;
                padding: 6px 14px;
                border-radius: 0px 8px 0px 8px;
                .tips1{
                    font-size: 14px;
                    font-weight: bold;
                    color: #FE4D45;
                }
                .tips2{
                    font-size: 14px;
                    font-weight: bold;
                    color: #00BE30;
                }
            }
            .iconImg{
                width: 30px;
                height: 30px;
                margin-right: 16px;
            }
            .num{
                font-size: 28px;
                font-weight: 600;
                color: #333333;
            }
            .name{
                font-size: 16px;
                font-weight: 400;
                color: #666666;
                margin: 10px 0 8px 0 ;
            }
            .desc{
                font-size: 13px;
                font-weight: 400;
                color: #999999;
            }
        }
}
.tabCheck{
    margin: 50px auto;
    .nav {
      display: flex;
      justify-content: center;
      align-items: center;
      position: relative;
      height: 60px;
      line-height: 72px;
      overflow: hidden;
      border-bottom: 1px solid #E4E1F5;
      margin: 50px auto 0;
      width: 1200px;
      .nav-item {
        position: relative;
        padding: 0 10px;
        // margin-right: 45px;
        bottom: 5px;
        color: #333333;
        font-size: 20px;
        cursor: pointer;
        &::before {
          content: "";
          position: absolute;
          bottom: -11px;
          left: 0;
          width: 100%;
          height: 4px;
          background-color: #555a7a;
          border-radius: 8px 8px 0 0;
        }
      }
      .nav-item:first-child{
        margin-right:145px ;
      }
      .nav-underline {
        position: absolute;
        bottom: 0;
        margin-left: 2px;
        display: block;
        height: 4px;
        top: 56px;
        border-radius: 8px 8px 0 0;
        background: #6461E7;
        transition: all 0.4s ease-in-out;
      }
      .navActive {
        color: #6461E7;
      }
    }
}
.bg1{
    position: absolute;
    top: 8px;
    right: -282px;
    width: 426px;
    height: 434px;
}
.orIcon{
    text-decoration:underline;
    color:#31FDFD
}
</style>